import React, { useState } from 'react';
import { Navigation } from './components/Navigation';
import { AboutMe } from './pages/AboutMe';
import { WorkPortfolio } from './pages/WorkPortfolio';
import { Resume } from './pages/Resume';
import { Contact } from './pages/Contact';
export function App() {
  const [activeTab, setActiveTab] = useState('about');
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-0">
      <Navigation activeTab={activeTab} setActiveTab={setActiveTab} data-id="element-1" />
      <main className="w-full" data-id="element-2">
        {activeTab === 'about' && <AboutMe setActiveTab={setActiveTab} data-id="element-3" />}
        {activeTab === 'portfolio' && <WorkPortfolio data-id="element-4" />}
        {activeTab === 'resume' && <Resume data-id="element-5" />}
        {activeTab === 'contact' && <Contact data-id="element-6" />}
      </main>
      <footer className="w-full bg-gray-900 text-white py-8 mt-16" data-id="element-7">
        <div className="max-w-6xl mx-auto px-6 text-center" data-id="element-8">
          <p data-id="element-9">© 2024 Jake Jackson. All rights reserved.</p>
        </div>
      </footer>
    </div>;
}